import type { CSSProperties } from 'react';

export const cssProperties = {
  '--ds-inner-tab-sizing-height': '36px',
  '--ds-inner-tab-sizing-dropdown-gap': '5px',

  '--ds-inner-tab-inactive-bg': '#dee1e6',
  '--ds-inner-tab-inactive-close-bg': 'rgba(0, 0, 0, 0)',
  '--ds-inner-tab-inactive-hover-close-bg': 'rgba(127, 126, 132, 0.3)',
  '--ds-inner-tab-active-close-bg': 'rgba(0, 0, 0, 0)',
  '--ds-inner-tab-active-hover-close-bg': 'rgba(127, 126, 132, 0.3)',

  '--ds-inner-tab-hover-and-active-bg': '#ffffff',
  '--ds-inner-tab-divider-color': '#b5b5b5',
} as CSSProperties;
